import {
  ALLIED_EXPRESS_CARRIER_TYPE,
  COURIERS_PLEASE_CARRIER_TYPE,
  EPARCEL_CARRIER_TYPE,
  HUBBED_CARRIER_TYPE,
  MORNING_EXPRESS_CARRIER_TYPE,
  NINJA_VAN_CARRIER_TYPE,
  SING_POST_CARRIER_TYPE,
  TELEPORT_CARRIER_TYPE,
} from '../types/carrier';
import { Settings } from '../types/settings';

export const mockSettings: Settings = {
  authorisation_email: 'some@email.com',
  dropoff_enabled: true,
  dropoff_flat_rate: 5.95,
  pickup_enabled: true,
  pickup_flat_rate: 12.95,
  returns_store_name: 'Shippit Pty Ltd',
  hubbed_enabled: true,
  eparcel_dropoff_enabled: true,
  merchant_address: '120 Test St',
  enable_new_fields_for_au: true,
  dropoff_providers: [HUBBED_CARRIER_TYPE, EPARCEL_CARRIER_TYPE],
  pickup_providers: [COURIERS_PLEASE_CARRIER_TYPE, ALLIED_EXPRESS_CARRIER_TYPE],
};

export const mockSingaporeSettings: Settings = {
  authorisation_email: 'some@email.com.sg',
  dropoff_enabled: true,
  dropoff_flat_rate: 5.95,
  pickup_enabled: true,
  pickup_flat_rate: 12.95,
  returns_store_name: 'Shippit Pte Ltd',
  hubbed_enabled: false,
  eparcel_dropoff_enabled: false,
  merchant_address: '120 Test St',
  dropoff_providers: [SING_POST_CARRIER_TYPE, NINJA_VAN_CARRIER_TYPE],
  pickup_providers: [TELEPORT_CARRIER_TYPE],
};

export const mockMalaysianSettings: Settings = {
  authorisation_email: 'some@email.com.my',
  dropoff_enabled: true,
  dropoff_flat_rate: 5.95,
  pickup_enabled: true,
  pickup_flat_rate: 12.95,
  returns_store_name: 'Shippit Pte Ltd',
  hubbed_enabled: false,
  eparcel_dropoff_enabled: false,
  merchant_address: '120 Test St',
  dropoff_providers: [NINJA_VAN_CARRIER_TYPE],
  pickup_providers: [TELEPORT_CARRIER_TYPE],
};

export const mockHongKongSettings: Settings = {
  authorisation_email: 'some@email.com.hk',
  dropoff_enabled: true,
  dropoff_flat_rate: 5.95,
  pickup_enabled: true,
  pickup_flat_rate: 12.95,
  returns_store_name: 'Shippit Pte Ltd',
  hubbed_enabled: false,
  eparcel_dropoff_enabled: false,
  merchant_address: '120 Test St',
  dropoff_providers: [MORNING_EXPRESS_CARRIER_TYPE],
  pickup_providers: [],
};

export const mockPhilipinesSettings: Settings = {
  authorisation_email: 'some@email.com.ph',
  dropoff_enabled: true,
  dropoff_flat_rate: 5.95,
  pickup_enabled: true,
  pickup_flat_rate: 12.95,
  returns_store_name: 'Shippit',
  hubbed_enabled: false,
  eparcel_dropoff_enabled: false,
  merchant_address: '120 Test St',
  dropoff_providers: [NINJA_VAN_CARRIER_TYPE],
  pickup_providers: [NINJA_VAN_CARRIER_TYPE],
};

export const mockIndonesiaSettings: Settings = {
  authorisation_email: 'some@email.com.id',
  dropoff_enabled: true,
  dropoff_flat_rate: 5.95,
  pickup_enabled: true,
  pickup_flat_rate: 12.95,
  returns_store_name: 'Shippit',
  hubbed_enabled: false,
  eparcel_dropoff_enabled: false,
  merchant_address: '120 Test St',
  dropoff_providers: [NINJA_VAN_CARRIER_TYPE],
  pickup_providers: [NINJA_VAN_CARRIER_TYPE],
};

export const settingsByCountry = (countryCode: string) => {
  switch (countryCode) {
    case 'SG':
      return mockSingaporeSettings;
    case 'MY':
      return mockMalaysianSettings;
    case 'HK':
      return mockHongKongSettings;
    case 'PH':
      return mockPhilipinesSettings;
    case 'ID':
      return mockIndonesiaSettings;
    default:
      return mockSettings;
  }
};
